
let routes = [{
    path: '/login',
    component: () =>
        import('@/views/login.vue'),
    hidden: true,
    meta: {
        requireAuth: false
    }
},
{
    path: '/',
    component: () =>
        import('@/views/home.vue'),
    iconCls: 'el-icon-house', //图标样式class
    leaf: true, //只有一个节点
    children: [{
        path: '/',
        component: () =>
            import('@/views/index/index.vue'),
        name: '首页',

    }]
},
  {
    path: '/menu',
    component: () =>
      import('@/views/home.vue'),
    iconCls: 'el-icon-house', //图标样式class
    leaf: true, //只有一个节点
    children: [{
      path: '/menu/client',
      component: () =>
        import('@/views/menu/index.vue'),
      name: '菜单管理',

    },{
      path: '/menu/systemRole',
      component: () =>
        import('@/views/menu/systemRole.vue'),
      name: '系统角色',

    },{
      path: '/menu/roleMenu',
      component: () =>
        import('@/views/menu/roleMenu.vue'),
      name: '绑定角色',

    }]
  },
{
    path: '/store',
    component: () =>
        import('@/views/home.vue'),
    name: '门店管理',
    iconCls: 'el-icon-school', //图标样式class
    children: [{
        path: '/store/equipment',
        component: () =>
            import('@/views/store/equipment'),
        name: '设备管理',

    }, {
        path: '/store/shop',
        component: () =>
            import('@/views/store/shop'),
        name: '门店管理',

    }, {
      path: '/store/storeLabel',
      component: () =>
        import('@/views/store/storeLabel'),
      name: '门店标签',

    },
      {
        path: '/store/signSlogan',
        component: () =>
            import('@/views/store/signSlogan'),
        name: '签到标语管理',

    }, {
        path: '/store/coachEvaluation',
        component: () =>
            import('@/views/store/coachEvaluation'),
        name: '教练评价标签管理',

    }, {
        path: '/store/bossAccount',
        component: () =>
            import('@/views/store/bossAccount'),
        name: 'Boss账户管理',

    },]
},
// 内容管理

{
    path: '/content',
    component: () =>
        import('@/views/home.vue'),
    name: '内容管理',
    iconCls: 'el-icon-notebook-2', //图标样式class
    children: [{
        path: '/content/aboutUs',
        component: () =>
            import('@/views/content/aboutUs'),
        name: '关于我们管理',
        meta: {
            requireAuth: true
        }
    }, {
        path: '/content/advertisingSpace',
        component: () =>
            import('@/views/content/advertisingSpace'),
        name: '广告位管理',
        meta: {
            requireAuth: true
        }
    }, {
        path: '/content/article',
        component: () =>
            import('@/views/content/article'),
        name: '文章管理',
        meta: {
            requireAuth: true
        }
    }, {
      path: '/content/storeArticle',
      component: () =>
        import('@/views/content/storeArticle'),
      name: '门店文章审核',
      meta: {
        requireAuth: true
      }
    }, {
        path: '/content/storeActivity',
        component: () =>
            import('@/views/content/storeActivity'),
        name: '门店活动推荐管理',
        meta: {
            requireAuth: true
        }
    }, {
        path: '/content/innovation',
        component: () =>
            import('@/views/content/innovation'),
        name: '协同创新报名信息',
        meta: {
            requireAuth: true
        }
    }, {
        path: '/content/coachRecruitmen',
        component: () =>
            import('@/views/content/coachRecruitmen'),
        name: '教练招募信息',
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/content/trainingIntention',
        component: () =>
            import('@/views/content/trainingIntention'),
        name: '教练培训意向报名信息',
        meta: {
            requireAuth: true
        }
    },

    {
        path: '/content/updateLog',
        component: () =>
            import('@/views/content/updateLog'),
        name: '更新日志',
    }

    ]
},

// 用户管理
{
    path: '/user',
    component: () =>
        import('@/views/home.vue'),
    iconCls: 'el-icon-user', //图标样式class
    leaf: true, //只有一个节点
    children: [{
        path: '/',
        component: () =>
            import('@/views/user/index'),
        name: '用户管理',

    }]
},

// 组织架构
  {
    path: '/organiZational',
    component: () =>
      import('@/views/home.vue'),
    iconCls: 'el-icon-user', //图标样式class
    leaf: true, //只有一个节点
    children: [{
      path: '/',
      component: () =>
        import('@/views/organiZational/index'),
      name: '组织管理',

    }]
  },
// 订单管理

{
    path: '/order',
    component: () =>
        import('@/views/home.vue'),
    name: '订单管理',
    iconCls: 'el-icon-document-copy', //图标样式class
    children: [{
        path: '/order/membershipCardOrder',
        component: () =>
            import('@/views/order/membershipCardOrder'),
        name: '会员卡订单',

    }, {
        path: '/order/courseOrder',
        component: () =>
            import('@/views/order/courseOrder'),
        name: '课程订单',

    }, {
      path: '/order/trainOrder',
      component: () =>
        import('@/views/order/trainOrder'),
      name: '培训班订单',

    },{
      path: '/order/membershipCabinet',
      component: () =>
        import('@/views/order/membershipCabinet'),
      name: '租柜订单记录',

    }]
},


// 财务管理

{
    path: '/finance',
    component: () =>
        import('@/views/home.vue'),
    name: '财务管理',
    iconCls: 'el-icon-pie-chart', //图标样式class
    children: [{
        path: '/finance/accountStatement',
        component: () =>
            import('@/views/finance/accountStatement'),
        name: '账单管理',

    }, {
        path: '/finance/storeFlow',
        component: () =>
            import('@/views/finance/storeFlow'),
        name: '门店流水',

    }]
},


// 系统管理

{
    path: '/system',
    component: () =>
        import('@/views/home.vue'),
    name: '系统管理',
    iconCls: 'el-icon-setting', //图标样式class
    children: [{
        path: '/system/role',
        component: () =>
            import('@/views/system/role'),
        name: '角色管理',

    }, {
        path: '/system/backstageUser',
        component: () =>
            import('@/views/system/backstageUser'),
        name: '后台用户管理',

    },
    {
        path: '/system/systemLog',
        component: () =>
            import('@/views/system/systemLog'),
        name: '系统操作日志',
    },
    {
        path: '/system/defaultStore',
        component: () =>
            import('@/views/system/defaultStore'),
        name: '设置默认门店',
    }, {
        path: '/system/configuration',
        component: () =>
            import('@/views/system/configuration'),
        name: '参数配置',
    }, {
        path: '/system/port',
        component: () =>
          import('@/views/system/port'),
        name: '接口管理',
      }
    ],
},
//规则引擎
{
    path: '/rule',
    component: () =>
        import('@/views/home.vue'),
    name: '规则引擎',
    iconCls: 'el-icon-setting', //图标样式class
    children: [{
        path: '/rule/rule-group',
        component: () =>
            import('@/views/rule/rule-group'),
        name: '规则群组',

    }, {
        path: '/rule/rule-template',
        component: () =>
            import('@/views/rule/rule-template'),
        name: '规则模板',

    }, {
        path: '/rule/rule-list',
        component: () =>
        import('@/views/rule/rule-list'),
        name: '系统规则',
    }, {
        path: '/rule/rule-template-add',
        component: () =>
        import('@/views/rule/rule-template-add'),
        name: '添加规则模板',
    }, {
        path: '/rule/system-list',
        component: () =>
        import('@/views/rule/system-list'),
        name: '项目管理',
    }
    ]
},
];


export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js